module.exports = __webpack_public_path__ + "static/media/ic_preview.f050fe47.svg";